<mat-card appearance="outlined" class='or-notification-banner'
          [ngClass]='getStatusClass()'
          [ngStyle]="{'width.px': width, 'height.px': height }">
  <mat-card-header data-cy="notification-header" [ngClass]='getStatusClass()'>
    <mat-icon>{{getIcon()}}</mat-icon>
    <span class='margin-left-10'></span>
    {{header}}
  </mat-card-header>
  <mat-card-content data-cy="notification-content">
    {{content}}
    <span class="p-4">
      <ng-content></ng-content>
    </span>
      @if(showButton) {
       <div class="pt-2 pl-4 pb-4">
          <button
            mat-raised-button
            [matTooltip]="buttonText"
            (click)="onClick()"
            data-cy="notification-btn-action">
            <mat-icon class="text-xl-center" fontIcon="add_circle" />
            <span class="text-lg"> {{buttonText}}</span>
          </button>
       </div>
      }
  </mat-card-content>
</mat-card>

